//
// client-mgmt-modify.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* jshint devel: true */
/* global angular: false, _: false, ClientMgmtSelectObject: false */

((() => {
    angular.module('curalate').directive('clientMgmtModify',
        ['$location', 'ClientMgmtApiService', 'ClientMgmtPageState', ($location, ClientMgmtApiService, ClientMgmtPageState) => ({
            restrict: 'E',
            templateUrl: '/app/components/client-mgmt/modify/client-mgmt-modify.html',
            scope: {},

            controller: ['$scope', $scope => {
                $scope.$watch('model.groups.selectedItem', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        const groupId = $scope.model.groups.findIdForItem(newValue);
                        if (groupId !== undefined) {
                            $scope.model.clients.populate(() => ClientMgmtApiService.asyncGetClientsByGroup(groupId));
                        } else {
                            $scope.model.pageState.setError(`Could not find group information for ${newValue}`);
                        }
                    }
                });

                $scope.$watch('model.clients.selectedItem', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        const clientId = $scope.model.clients.findIdForItem(newValue);
                        if (clientId !== undefined) {
                            $scope.model.pageState.clearResults();  // When changing clients, clear success vs. failure
                            $scope.model.populateClientInfo(clientId);
                            $scope.model.bvRegions.selectedItem = null;
                            $scope.model.bvClientIds.selectedItem = null;
                            $scope.model.bazaarvoiceClientId.selectedItem = null;
                            $scope.model.bvDisplayName.selectedItem = null;
                            $scope.model.salesforceId.selectedItem = null;
                            $scope.model.salesforceIDForCreate = null;
                            $scope.model.billingId.selectedItem = null;
                            $scope.model.billingIDForCreate = null;
                            $scope.model.bvCluster.selectedItem = null;
                            $scope.model.jiraTicket = null;
                            $scope.model.useBVInstanceName = false;
                            $scope.model.bvActionComplete = false;
                            $scope.model.bvCreateInProgress = false;
                            $scope.model.bvCreateComplete = false;
                            $scope.model.selectService = 'CV2';
                            $scope.model.createBVclient = null;
                        } else {
                            $scope.model.pageState.setError(`Could not find client information for ${newValue}`);
                        }
                    }
                });
            }],

            link(scope, element, attributes) {
                // Scope bound functions and variables
                scope.model = {

                    // General page state: success, error, outstandingRequests
                    pageState: ClientMgmtPageState,

                    // selectable fields
                    groups: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'groups'),
                    clients: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'clients'),
                    users: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'users'),
                    funnelStages: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'funnelStages'),
                    bazaarvoiceClientId: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bazaarvoiceClientId'),
                    bvRegions: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bvRegions'),

                    bvDisplayName: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bvDisplayName'),
                    salesforceId: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'salesforceId'),
                    billingId: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'billingId'),
                    bvCluster: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bvCluster'),
                    bvClientIds: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'bvClientIds'),
                    createBVclient: null,
                    jiraTicket: null,
                    useBVInstanceName: false,
                    bvActionComplete: false,
                    bvCreateInProgress: false,
                    bvCreateComplete: false,
                    selectService: null,
                    salesforceIDForCreate: null,
                    billingIDForCreate: null,

                    funnelStagesCanExpire: {},

                    // client info with selectable expiration time
                    clientInfo: null,
                    clientExpiresOn: new ClientMgmtSelectObject(ClientMgmtApiService, ClientMgmtPageState, 'expiresOn'),
                };

                scope.model.enableButton = () => !scope.model.pageState.disableInput() &&
                       (scope.model.funnelStages.isDirty() ||
                        scope.model.clientExpiresOn.isDirty() ||
                        scope.model.users.isDirty() ||
                           (scope.model.bazaarvoiceClientId.isDirty() && scope.model.bvActionComplete));

                scope.model.submit = () => {
                    scope.model.pageState.startAsyncAction();

                    // fire off the rpc request to modify the client
                    ClientMgmtApiService.asyncModifyClient(
                        scope.model.clientInfo.clientId,
                        scope.model.clientExpiresOn.isDirty(),
                        scope.model.clientExpiresOn.getOriginalId(),
                        scope.model.clientExpiresOn.getSelectedId(),
                        scope.model.users.isDirty(),
                        scope.model.users.getOriginal(),
                        scope.model.users.getSelected(),
                        scope.model.funnelStages.isDirty(),
                        scope.model.funnelStages.getOriginal(),
                        scope.model.funnelStages.getSelected(),
                        scope.model.bazaarvoiceClientId.isDirty(),
                        scope.model.bazaarvoiceClientId.getOriginal(),
                        scope.model.bazaarvoiceClientId.getSelected(),
                        scope.model.bvDisplayName.getOriginal(),
                        scope.model.bvDisplayName.getSelected(),
                        scope.model.bvCluster.getOriginal(),
                        scope.model.bvCluster.getSelected(),
                        scope.model.salesforceId.getOriginal(),
                        scope.model.salesforceId.getSelected(),
                        scope.model.billingId.getOriginal(),
                        scope.model.billingId.getSelected()
                    ).then(() => {
                        scope.model.pageState.setSuccess('Changes Committed');
                        scope.model.clientExpiresOn.setOriginalToSelected();
                        scope.model.users.setOriginalToSelected();
                        scope.model.funnelStages.setOriginalToSelected();
                        scope.model.bazaarvoiceClientId.setOriginalToSelected();
                        scope.model.bvDisplayName.setOriginalToSelected();
                        scope.model.salesforceId.setOriginalToSelected();
                        scope.model.billingId.setOriginalToSelected();
                        scope.model.bvCluster.setOriginalToSelected();
                        scope.model.bvRegions.selectedItem = null;
                        scope.model.bvClientIds.selectedItem = null;
                        scope.model.bazaarvoiceClientId.selectedItem = null;
                        scope.model.bvDisplayName.selectedItem = null;
                        scope.model.salesforceId.selectedItem = null;
                        scope.model.salesforceIDForCreate = null;
                        scope.model.billingId.selectedItem = null;
                        scope.model.billingIDForCreate = null;
                        scope.model.bvCluster.selectedItem = null;
                        scope.model.jiraTicket = null;
                        scope.model.useBVInstanceName = false;
                        scope.model.bvActionComplete = false;
                        scope.model.bvCreateInProgress = false;
                        scope.model.bvCreateComplete = false;
                        scope.model.selectService = 'CV2';
                        scope.model.createBVclient = null;
                        // re-load info in case the server made adjustments (e.g. changing expire time due to
                        // changing funnelTypes)
                        scope.model.populateClientInfo(scope.model.clientInfo.clientId);
                    }).catch(err => {
                        scope.model.pageState.setError(`Error committing changes: ${err}`);
                    });
                };

                const retrieveBVClientRecord = (clientId, serviceName) => {
                    ClientMgmtApiService.asyncGetBVClientRecord(clientId, serviceName)
                        .then(clientRecord => {
                            scope.model.bazaarvoiceClientId.selectedItem = clientId;
                            scope.model.bvDisplayName.selectedItem = clientRecord.displayName;
                            scope.model.bvCluster.selectedItem = clientRecord.cluster;
                            scope.model.salesforceId.selectedItem = clientRecord.salesforceAccountId;
                            scope.model.bvActionComplete = true;
                            scope.model.pageState.clearResults();
                        })
                        .catch(err => {
                            scope.model.bvActionComplete = false;
                            scope.model.pageState.setError(`Error: ${err}`);
                        });
                };

                const retrieveAnyBVClientRecord = (clientId) => {
                    ClientMgmtApiService.asyncGetAnyBVClientRecord(clientId)
                        .then(clientRecord => {
                            scope.model.bazaarvoiceClientId.selectedItem = clientId;
                            scope.model.bvDisplayName.selectedItem = clientRecord.displayName;
                            scope.model.bvCluster.selectedItem = clientRecord.cluster;
                            scope.model.salesforceId.selectedItem = clientRecord.salesforceAccountId;
                            scope.model.bvActionComplete = true;
                            scope.model.pageState.clearResults();
                        })
                        .catch(err => {
                            scope.model.bvActionComplete = false;
                            scope.model.pageState.setError(`Error: ${err}`);
                        });
                };

                scope.model.getBVClientRecord = () => {
                    if (scope.model.selectService === 'CV2' && scope.model.bvClientIds.selectedItem != null) {
                        retrieveBVClientRecord(scope.model.bvClientIds.selectedItem, scope.model.selectService);
                    } else if (scope.model.selectService === 'Connections' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        retrieveBVClientRecord(scope.model.bazaarvoiceClientId.selectedItem, scope.model.selectService);
                    } else if (scope.model.selectService === 'Curalate' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        retrieveAnyBVClientRecord(scope.model.bazaarvoiceClientId.selectedItem);
                    } else if (scope.model.selectService === 'prr' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        retrieveBVClientRecord(scope.model.bazaarvoiceClientId.selectedItem, scope.model.selectService);
                    }
                    else {
                        scope.model.pageState.clearResults();
                    }
                };

                scope.model.createBVClientRecord = () => {
                    scope.model.bvCreateInProgress = true;
                    if (/^([a-zA-Z0-9_-]+){2,31}$/.test(scope.model.bazaarvoiceClientId.selectedItem)) {
                        ClientMgmtApiService.asyncCreateBVCurOnlyClient(
                            scope.model.bazaarvoiceClientId.selectedItem,
                            scope.model.bvDisplayName.selectedItem,
                            scope.model.bvRegions.getSelectedId(),
                            scope.model.salesforceIDForCreate,
                            scope.model.billingIDForCreate
                        ).then(bvInstanceDetails => {
                            scope.model.salesforceId.selectedItem = bvInstanceDetails.salesforceID;
                            scope.model.billingId.selectedItem = bvInstanceDetails.billingID;
                            scope.model.bvCluster.selectedItem = bvInstanceDetails.cluster;
                            scope.model.jiraTicket = bvInstanceDetails.jiraTicket;
                            scope.model.bvActionComplete = true;
                            scope.model.bvCreateComplete = true;
                            scope.model.pageState.clearResults();
                            scope.model.bvCreateInProgress = false;
                        }).catch(err => {
                            scope.model.bvCreateInProgress = false;
                            scope.model.bvActionComplete = false;
                            scope.model.bvCreateComplete = false;
                            scope.model.pageState.setError(`Error triggering provisioning of the bv client instance: ${err}`);
                        });
                    } else if (scope.model.salesforceIDForCreate.length !== 18) {
                        scope.model.bvCreateInProgress = false;
                        scope.model.bvActionComplete = false;
                        scope.model.bvCreateComplete = false;
                        scope.model.pageState.setError('Error occurred: Salesforce ID is required and must be 18 characters.');
                    } else {
                        scope.model.bvCreateInProgress = false;
                        scope.model.bvActionComplete = false;
                        scope.model.bvCreateComplete = false;
                        scope.model.pageState.setError('Error occurred: Instance name is invalid. Instance name must be between 2 and 31 characters and only contain alpha characters, numbers, dash and underscores');
                    }
                };

                const getBVClients = () => {
                    ClientMgmtApiService.asyncSearchBVClients()
                        .then(clients => {
                            scope.model.bvClientIds.itemNames = clients.values;
                        });
                };

                scope.model.allowExpiresOnModification = () => scope.model.funnelStageCanExpire() && scope.model.clientTypeCanExpire();

                scope.model.clientTypeCanExpire = () => {
                    return scope.model.clientInfo.clientType !== 'Syndication' && scope.model.clientInfo.clientType !== 'Affiliate';
                };

                scope.model.funnelStageCanExpire = () => {
                    if (scope.model.funnelStages.originalItem in scope.model.funnelStagesCanExpire) {
                        return scope.model.funnelStagesCanExpire[scope.model.funnelStages.originalItem];
                    }
                    // Allow the expiration time to modified (Unknown case)
                    return true;
                };

                scope.model.populateClientInfo = clientId => {
                    // Load the account types and then the client information
                    ClientMgmtApiService.asyncGetFunnelStages('valid').then(details => {
                        scope.model.funnelStages.populateFromMap(details);
                        _.each(details, element => {
                            if (element.hasOwnProperty('name') && element.hasOwnProperty('canExpire')) {
                                scope.model.funnelStagesCanExpire[element.name] = element.canExpire;
                            } else {
                                scope.model.pageState.setError('Invalid elements in funnelStages');
                                return;
                            }
                        });

                        // Now get the client info
                        ClientMgmtApiService.asyncGetClientInfo(clientId).then(details => {
                            scope.model.clientInfoSet(details);
                            const baseVibeUrl = /qa|localhost/.test(location.origin) ? 'https://qa.vibe.bazaarvoice.com' : 'https://vibe.bazaarvoice.com';
                            scope.model.vibeClientUrl = `${baseVibeUrl}?clientId=${scope.model.clientInfo.clientId}`;
                        }).catch(err => {
                            scope.model.pageState.setError(`Error failed to load client info for ${clientId}: ${err}`);
                        });
                    }).catch(err => {
                        scope.model.pageState.setError(`Error failed to funnelStages: ${err}`);
                    });
                };

                scope.model.clientInfoSet = ci => {
                    if (ci.createdOn !== 0) {
                        ci.createdOn = new Date(ci.createdOn).toLocaleDateString();
                    } else {
                        ci.createdOn = 'Unknown';
                    }

                    // Setup expires
                    const expiresOnMap = [];
                    scope.model.addExpiresOnSelection(expiresOnMap, ci.expiresOn);

                    // Now add an additional choice if within a certain threshold or already expired
                    const nowTimeMs = (new Date()).getTime();
                    const defaultExpiresOnExtension = (90 * 24 * 60 * 60 * 1000);
                    const addExpiresOnExtensionThreshold = (((defaultExpiresOnExtension) * 70) / 100);
                    if ((ci.expiresOn <= nowTimeMs) || ((ci.expiresOn - nowTimeMs) <= addExpiresOnExtensionThreshold)) {
                        scope.model.addExpiresOnSelection(expiresOnMap, nowTimeMs + defaultExpiresOnExtension);
                    }
                    scope.model.clientExpiresOn.populateFromMap(expiresOnMap);

                    // setup the account types to handle ones that no longer exist (or unknown)
                    scope.model.funnelStages.setInitialSelected(ci.funnelStage);

                    // Setup the users to handle unknown or users that don't exist
                    scope.model.users.setInitialSelected(ci.ownedBy);

                    // Setup the BV Client Id
                    scope.model.bazaarvoiceClientId.setInitialSelected(ci.bazaarvoiceClientId);

                    scope.model.bvDisplayName.setInitialSelected(ci.bazaarvoiceDisplayName);

                    scope.model.bvCluster.setInitialSelected(ci.bvCluster);

                    scope.model.salesforceId.setInitialSelected(ci.salesforceId);

                    scope.model.billingId.setInitialSelected(ci.billingId);

                    scope.model.clientInfo = ci;
                };

                scope.model.addExpiresOnSelection = (expiresOnMap, timeInMs) => {
                    let timeInMsStr = null;
                    if (timeInMs !== 0) {
                        timeInMsStr = new Date(timeInMs).toLocaleDateString();
                    } else {
                        timeInMsStr = 'Unknown';
                    }

                    if (_.size(expiresOnMap) === 0) {
                        scope.model.clientExpiresOn.setDefault(timeInMsStr);
                    }

                    // Put into id/name pair to re-use ClientMgmtSelectObject
                    // Will push value to server using the id in this case instead of the name
                    expiresOnMap.push({ 'id': timeInMs, 'name': timeInMsStr });
                };

                const getGroupArg = () => {
                    const params = $location.search();
                    return (typeof params.group === 'undefined') ? 'Curalate' : params.group;
                };

                const getClientArg = () => {
                    const params = $location.search();
                    return (typeof params.client === 'undefined') ? 'Unknown' : params.client;
                };

                const getBVRegions = () => {
                    ClientMgmtApiService.asyncGetRegions()
                        .then(regions => {
                            const itemNames = [];
                            const map = {};
                            for (let i = 0; i < regions.regions.length; i++) {
                                itemNames.push(regions.regions[i].description);
                                map[regions.regions[i].description] = regions.regions[i].ID;
                            }
                            scope.model.bvRegions.itemNames = itemNames;
                            scope.model.bvRegions.map = map;
                        });
                };

                // initialize
                scope.model.pageState.init();
                getBVClients();
                scope.model.selectService = 'CV2';
                scope.model.pageState.setClearSuccessTimeout(2000);
                scope.model.groups.setDefault(getGroupArg());
                scope.model.groups.populate(ClientMgmtApiService.asyncGetGroups);
                scope.model.clients.setDefault(getClientArg());
                scope.model.users.populate(ClientMgmtApiService.asyncGetUsers);
                getBVRegions();
                scope.model.pageState.initFinished();

                const pacmanHealthCheck = () => {
                    if (scope.model.createBVclient === 'yes') {
                        ClientMgmtApiService.asyncPacmanHealthCheck()
                            .then(serviceOK => {
                                if (serviceOK === true || serviceOK === 'true') {
                                    scope.model.pageState.clearResults();
                                }
                            })
                            .catch(err => {
                                scope.model.pageState.setError(`Pacman health check failed: ${err}`);
                            });
                    }
                };

                const rosettaHealthCheck = () => {
                    ClientMgmtApiService.asyncRosettaHealthCheck()
                        .then(serviceOK => {
                            if (serviceOK === true || serviceOK === 'true') {
                                scope.model.pageState.clearResults();
                            }
                        })
                        .catch(err => {
                            scope.model.pageState.setError(`Rosetta health check failed: ${err}`);
                        });
                };
                scope.$watch('model.bazaarvoiceClientId.selectedItem', pacmanHealthCheck);
                scope.$watch('model.bazaarvoiceClientId.selectedItem', rosettaHealthCheck);
                scope.$watch('model.bvClientIds.selectedItem', pacmanHealthCheck);
                scope.$watch('model.bvClientIds.selectedItem', rosettaHealthCheck);

                const checkBVClientRecordDoesNotExist = () => {
                    if (scope.model.createBVclient === 'yes' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        ClientMgmtApiService.asyncDoesBVClientExist(scope.model.bazaarvoiceClientId.selectedItem)
                            .then(exists => {
                                if (exists === true || exists === 'true') {
                                    scope.model.useBVInstanceName = false;
                                    scope.model.pageState.setError('BV Client already exists');
                                } else {
                                    scope.model.useBVInstanceName = true;
                                    scope.model.pageState.clearResults();
                                }
                            })
                            .catch(err => {
                                scope.model.pageState.setError('Error occurred: Instance name is invalid. Instance name must only contain alpha characters, numbers, dash and underscores');
                            });
                    } else {
                        scope.model.pageState.clearResults();
                    }
                };
                scope.$watch('model.bazaarvoiceClientId.selectedItem', checkBVClientRecordDoesNotExist);

                const doesBVClientExist = (clientId) => {
                    ClientMgmtApiService.asyncDoesBVClientExist(clientId)
                        .then(exists => {
                            if (exists === true || exists === 'true') {
                                scope.model.useBVInstanceName = true;
                                scope.model.pageState.clearResults();
                            } else {
                                scope.model.useBVInstanceName = false;
                                scope.model.pageState.setError('BV Client does not exist');
                            }
                        })
                        .catch(err => {
                            scope.model.pageState.setError('Error occurred: Instance name is invalid. Illegal character. Instance name must only contain alpha characters, numbers, dash and underscores');
                        });
                };

                const checkBVClientRecordExists = () => {
                    if (scope.model.selectService === 'Connections' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        doesBVClientExist(scope.model.bazaarvoiceClientId.selectedItem);
                    } else if (scope.model.selectService === 'Curalate' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        doesBVClientExist(scope.model.bazaarvoiceClientId.selectedItem);
                    } else if (scope.model.selectService === 'prr' && scope.model.bazaarvoiceClientId.selectedItem != null) {
                        doesBVClientExist(scope.model.bazaarvoiceClientId.selectedItem);
                    }
                    else {
                        scope.model.pageState.clearResults();
                    }
                };
                scope.$watch('model.bazaarvoiceClientId.selectedItem', checkBVClientRecordExists);

                const searchBVClientRecords = () => {
                    if (scope.model.createBVclient === 'no') {
                        ClientMgmtApiService.asyncSearchBVClients(scope.model.bvClientIds.selectedItem)
                            .then(clients => {
                                scope.model.bvClientIds.itemNames = clients.values;
                                if (clients.values.includes(scope.model.bvClientIds.selectedItem)) {
                                    scope.model.useBVInstanceName = true;
                                } else {
                                    scope.model.useBVInstanceName = false;
                                }
                            })
                            .catch(err => {
                                scope.model.useBVInstanceName = false;
                                scope.model.pageState.setError(`Error: Invalid client name. ${err}`);
                            });
                    } else {
                        scope.model.pageState.clearResults();
                    }
                };
                scope.$watch('model.bvClientIds.selectedItem', searchBVClientRecords);

                const resetBVFieldsAll = () => {
                    scope.model.bvRegions.selectedItem = null;
                    scope.model.bvClientIds.selectedItem = null;
                    scope.model.bazaarvoiceClientId.selectedItem = null;
                    scope.model.bvDisplayName.selectedItem = null;
                    scope.model.salesforceId.selectedItem = null;
                    scope.model.salesforceIDForCreate = null;
                    scope.model.billingId.selectedItem = null;
                    scope.model.billingIDForCreate = null;
                    scope.model.bvCluster.selectedItem = null;
                    scope.model.jiraTicket = null;
                    scope.model.useBVInstanceName = false;
                    scope.model.bvActionComplete = false;
                    scope.model.bvCreateInProgress = false;
                    scope.model.bvCreateComplete = false;
                    scope.model.selectService = 'CV2';
                };
                scope.$watch('model.createBVclient', resetBVFieldsAll);

                const resetBVFields = () => {
                    scope.model.bvRegions.selectedItem = null;
                    scope.model.bvClientIds.selectedItem = null;
                    scope.model.bazaarvoiceClientId.selectedItem = null;
                    scope.model.bvDisplayName.selectedItem = null;
                    scope.model.salesforceId.selectedItem = null;
                    scope.model.salesforceIDForCreate = null;
                    scope.model.billingId.selectedItem = null;
                    scope.model.billingIDForCreate = null;
                    scope.model.bvCluster.selectedItem = null;
                    scope.model.jiraTicket = null;
                    scope.model.useBVInstanceName = false;
                    scope.model.bvActionComplete = false;
                    scope.model.bvCreateInProgress = false;
                    scope.model.bvCreateComplete = false;
                };
                scope.$watch('model.selectService', resetBVFields);
            },
        })]);
}))();
